import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetFinanceAccountsRequestModel, GetFinanceAccountsResponseModel } from "@/features/accounts/finance/services/get-accounts-model";

export class GetFinanceAccountsApi {
  /**
   * 銀行口座取得API
   */
  public getFinanceAccounts = async (
    param: GetFinanceAccountsRequestModel
  ): Promise<GetFinanceAccountsResponseModel[]> => {
    const path = `/api/financeaccounts/finances`;
    const res = await ApiClient.instance.get<GetFinanceAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
